const _ = require("lodash");
const GriddyDraw = require("../../../trainer/banvasView/util/GriddyDraw");
const GridGeometry = require("../../../trainer/util/GridGeometry");
const {flipYCoordsWithOffset} = require("../../util/ArrayUtil");

const colors = require("../../util/ColorUtil").getDiagramColors();

const DEFAULT_LINE_WIDTH_FACTOR = 8;
const DEFAULT_DOT_RADIUS_FACTOR = 1; // dot radius as factor of line width
const DEFAULT_LINE_COLOR = colors.black;
const DEFAULT_FILL_COLOR = colors.black;

const drawGridShapes = function(
	context,
	numCols,
	numRows,
	shapes,
	options = {}
) {
	const diagramSize = context.getSize();

	/* parsing */

	// dot thickness
	const dotRadiusFactor =
		Number(options.dotRadiusFactor) || DEFAULT_DOT_RADIUS_FACTOR;
	const dotRadius =
		dotRadiusFactor * context.lineWidth * DEFAULT_LINE_WIDTH_FACTOR;

	// fill full diagram space by default
	const x = options.x || dotRadius;
	const y = options.y || dotRadius;
	const w = options.w || diagramSize.width;
	const h = options.h || diagramSize.height;

	// arguments
	const scale = Number(options.scale) || 1;
	const showDots = !!options.showDots;

	// parse shapes
	if (!shapes) {
		shapes = [];
	} else if (!Array.isArray(shapes)) {
		shapes = [shapes];
	} // else right format, do nothing

	/* draw */
	context.scale(scale, scale);

	// build grid geometry
	const geometry = new GridGeometry(
		"square",
		numCols,
		numRows,
		options.geomProps || {}
	).withDimFromRect({x, y, w, h});
	const cartesianToCanvas = cartCoords =>
		geometry.getDrawVertex(...flipYCoordsWithOffset(cartCoords, numRows));

	// draw city walks with dots everywhere (if requested)
	if (showDots) {
		for (const col of _.range(numCols)) {
			for (const row of _.range(numRows)) {
				GriddyDraw.drawVertexDot(context, geometry, colors, col, row, {
					radiusOpt:
						context.lineWidth * DEFAULT_LINE_WIDTH_FACTOR * dotRadiusFactor,
				});
			}
		}
	}

	// draw lines, except have the option to fill the shape at the end
	// convert each point from cartesian to row, col
	for (const shapeItem of shapes) {
		const {points = "", width = 1, stroke = true, fill, round} = shapeItem;
		const fillColor = colors[fill] || DEFAULT_FILL_COLOR;
		const lineColor = colors[stroke] || DEFAULT_LINE_COLOR;
		const lineWidth = context.lineWidth * width;

		// parse points
		const parsedPoints = points
			.split(";")
			.map(xyStr => xyStr.split(",").map(Number))
			.filter(coord => coord.length === 2)
			.map(cartesianToCanvas);

		// parse opts
		// outline thickness, color, fill color, outline square

		// draw via points if is actual shape (more than 2 points)
		if (parsedPoints.length > 1) {
			context.save();
			context.lineWidth = lineWidth;
			context.strokeStyle = lineColor;
			context.fillStyle = fillColor;
			context.lineCap = round ? "round" : "square";
			context.lineJoin = round ? "round" : "miter";

			// store travelling around the shape as a procedure s.t. can be done multiple times
			context.bp();
			context.moveTo(...parsedPoints[0]);
			for (const nextPoint of parsedPoints.slice(1)) {
				context.lineTo(...nextPoint);
			}
			context.lineTo(...parsedPoints[0]);
			if (stroke) {
				context.stroke();
			}

			if (fill) {
				context.fill();
			}
			context.restore();
		}
	}
};

module.exports = {
	drawGridShapes,
};
